const routes = [
  {
    path: '/monitor/live',
    props: true,
    component: () => import('@/views/monitor/live/Live.vue')
  }
]

export default routes
